import State from './State';

/**
 * Getters are used to calculate values based off state. They are generally
 * used for filtering or formatting data.
 *
 * @class Getters
 * @package Store/Module/Global
 * @project ChalkySticks
 */
const getters = {
	/**
	 * Get the current language code
	 *
	 * @param State state
	 * @return string
	 */
	languageCode(state: typeof State): string {
		return state.languageCode || 'en-US';
	},

	/**
	 * Query parameters from URL
	 *
	 * @param State state
	 * @return IQueryParameters
	 */
	queryParameters(state: typeof State): IQueryParameters {
		return state.queryParameters || {};
	},
};

export default getters;
